module.exports = __webpack_public_path__ + "img/Fs_Ui_Info_Base_Center.3ae69766.png";